export const hidenMessageAPI = ["user-preferences-general"];
